import {http_client} from "@/plugins/http_client";

const getPreguntas = async() => http_client('/api/v1/preguntas-frecuentes/preguntas',{},'get')
const getRepuestas = async(id) => http_client(`/api/v1/preguntas-frecuentes/respuesta/${id}`,{},'get')

export default{
    getPreguntas,
    getRepuestas
}